import React, { useEffect, useState } from 'react'
import { Col, Input, Row, Form, Button } from 'antd'
import { useHistory } from 'react-router-dom'
import { translate } from 'react-i18next'
import CropImage from './../../helpers/CropImage'
import { checkTokenExpire } from '../../redux/actions/actions'
import { useDispatch, useSelector } from 'react-redux';
import { genVRoomToken, postEditUserProfile } from '../../helpers'
import { DESTROY_CONTEXT, GET_USER_PROFILE } from '../../redux/actions/type'
import { showSpinner, hideSpinner } from '../../redux/actions/actions'
import { isEmpty, isUndefined } from 'lodash'
import { Helmet } from 'react-helmet'

import analytics from '../../libs/analytics'


const EditUserProfile = ({ t, keycloak }) => {
    const dispatch = useDispatch()
    const history = useHistory();
    const [profilePic, setProfilePic] = useState("")
    const [cropImageProfile, setCropImageProfile] = useState("")
    const [imgProfile, setimgProfile] = useState("")
    const [displayError, setdisplayError] = useState({
        type: null,
        msg: ''
    })
    const displayName = useSelector(state => state.userProfileHistory.displayname)
    const [form] = Form.useForm();
    const getAvatar = useSelector(state => state.userProfileHistory.avatar)
    const contextInfo = useSelector(state => state.contextInfo)
    const formItemLayout =
    {
        labelCol: {
            span: 10,
            offset: 2
        },
        wrapperCol: {
            span: 20,
            offset: 2
        },
    }

    const tailLayout = {
        wrapperCol: { offset: 16, span: 8 },
    };
  
    const updateProfile = async (values) => {
        const url = `${window._env_.subscriberServiceBaseURL}/v1/updateProfile`

        try {
            const token = await genVRoomToken(keycloak)
            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Authorization': "Bearer " + token
                }
            }
            const { displayName } = values

            const formData = new FormData()
            if (!isUndefined(cropImageProfile) && cropImageProfile !== "") {
                let base64toBlob = new Blob([cropImageProfile], { type: 'text/plain' })
                formData.append("avatar", base64toBlob)
            }

            formData.append("displayName", displayName)
            const updateEditProfile = await postEditUserProfile(keycloak, url, config, formData)
            return updateEditProfile

        } catch (err) {
            console.log(err, 'update error')
        }

    }

    const onFinish = async values => {

        dispatch(checkTokenExpire)
        dispatch(showSpinner)
        let payload = {
            code: null,
            message: null
        }
        payload = await updateProfile(values)

        dispatch(hideSpinner)
        if (!isUndefined(payload) && payload.status === 200) {
            dispatch({
                type: DESTROY_CONTEXT
            })
            history.push("/portal/profile")
        }
    }

    const backToUserProfile = () => {
        history.push('/portal/profile')
    }

    const handleDisplayInput = (e) => {
        if (e.target.value.length >= 101) {
            setdisplayError({
                type: "error",
                msg: t('edit_profile.error.display_error')
            })
        }
    }
    const handleSubmitEditProfile = () => {
        analytics.sendEvent({
            category:'My Profile',
            action: 'MyProfile-OK-Button-Clicked',
        });
    }

    useEffect(() => {
        dispatch({
            type: GET_USER_PROFILE
        })
    }, [dispatch])


    useEffect(() => {
        form.setFieldsValue({
            displayName: displayName,
        })
    }, [dispatch, form, displayName])

    useEffect(() => {
        const testImage = (URL) => {
            if (!isEmpty(URL)) {
                var tester = new Image();
                tester.onload = imageFound;
                tester.onerror = imageNotFound;
                tester.src = URL;
            }
        }

        const imageFound = () => {
            if (!isEmpty(getAvatar)) {
                setimgProfile(getAvatar)
            } else {
                setimgProfile(contextInfo.avatar)
            }
        }

        const imageNotFound = () => {
            setimgProfile('')
        }

        if (!isEmpty(getAvatar)) {
            setimgProfile(getAvatar)
        } else {
            testImage(contextInfo.avatar)
        }

    }, [getAvatar, contextInfo.avatar])

    return (
        <div>
            <Helmet>
                <title>My Profile - Vroom</title>
            </Helmet>
            <section className="edit-profile">
                <Row type="flex" justify="center">
                    <Col xs={10} sm={10} md={10} lg={10}>
                        <div className="edit-profile-card">
                            <div className="header-text">
                                {t('edit_profile.header_text')}
                            </div>

                            <Form
                                layout="vertical"
                                {...formItemLayout}
                                className="form-edit-profile"
                                onFinish={onFinish}
                                form={form}
                            >
                                {/* <img src={getAvatar} style= /> */}
                                <CropImage getAvatar={imgProfile} t={t} profilePic={profilePic} setCropImageProfile={setCropImageProfile} setProfilePic={setProfilePic} />

                                <Form.Item
                                    name="displayName"
                                    label={t('edit_profile.input.display')}
                                    validateStatus={displayError.type}
                                    help={displayError.msg}
                                >
                                    <Input maxLength={101} placeholder={t('edit_profile.input.display')} onChange={handleDisplayInput} />
                                </Form.Item>

                                <Form.Item {...tailLayout}>
                                    <Button className="btn-submit-ok" type="danger" htmlType="submit" onClick={handleSubmitEditProfile}>
                                        {t('edit_profile.input.btn_ok')}
                                    </Button>
                                    <Button htmlType="button" className="btn-cancel" onClick={backToUserProfile}>
                                        {t('edit_profile.input.btn_cancel')}
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </section>
        </div >
    )
}

export default translate()(EditUserProfile)
